module.exports = __webpack_public_path__ + "static/media/glasses.94c3bcd2.svg";